import { Injectable } from '@angular/core';
//import HmacSHA256=require('crypto-js/hmac-sha256');
import * as CryptoJS from 'crypto-js';
import { environment } from '../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class Common {

    //Variables for Payment Gateway - Development
    EncryptionKey:string;
    strMerchantID:string = "5071";
    strServiceCode:string = "TEST";
    strInitiateTransactionURL:string = "http://sampark.chd.nic.in/epayupg/Requestpage.aspx";

    public static arrayToStringWithComma(arr, key, dbType): string {

        if (dbType == "integer") {
            return arr.map(function (obj) {
                return "" + obj[key] + "";
            }).join(', ');
        } else if (dbType == "string") {
            return arr.map(function (obj) {
                return "" + obj[key] + "'";
            }).join(', ');
        }
    }

    public GetHMACSHA256(data) {
        this.EncryptionKey = 'hFzZHOal';
        return CryptoJS.HmacSHA256(data,this.EncryptionKey).toString();
    };

    //Call WebView of Payment Gateway
    public CallPaymentGatewayApp(TransactionRefNo){
        //window.location.href = environment.PGURL + '/?transaction=' + TransactionRefNo;
        window.location.href = environment.PGURL + '/V1_Qfix/PGQFix/ReferralURL?intTransactionID='+TransactionRefNo;
    }
}
